/** Tema colori: la scelta vale sul dispositivo, la partenza la decide il titolare. */
export const TEMI = [
  { id: "chiaro", nome: "Chiaro", nota: "Massima leggibilità con la luce forte: pranzo e ufficio" },
  { id: "notte", nome: "Notte", nota: "Fondo scuro: di sera non acceca in sala e non si vede dal tavolo" },
  { id: "ambra", nome: "Ambra", nota: "Crema e terracotta: il tono caldo del locale" },
  { id: "riposo", nome: "Riposo", nota: "Verde-grigio smorzato: per i turni lunghi, niente bianco negli occhi" },
];

const KEY = "rh_tema";

export const applicaTema = (id) => {
  const t = TEMI.some((x) => x.id === id) ? id : "chiaro";
  if (t === "chiaro") delete document.documentElement.dataset.theme;
  else document.documentElement.dataset.theme = t;
  return t;
};

export const temaDispositivo = () => localStorage.getItem(KEY) || "";

export const salvaTema = (id) => {
  localStorage.setItem(KEY, id);
  return applicaTema(id);
};
